export const state = () => ({
	universities: [],
});

export const mutations = {
	setUniversities(state: any, payload: any) {
		state.universities = payload;
	},
};

export const getters = {
	getUniversities: (state: any) => state.universities,
};

export const actions = {
	getUniversities(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/universities', { params: payload })
				.then((res) => {
					state.commit('setUniversities', res.data);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	createUserUniversity(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/user-universities', payload)
				.then((res) => {
					this.$auth.setUser({
						...this.$auth.user,
						universities: res.data,
					});

					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	updateUserUniversity(state: any, payload: any) {
		const { user_university_uuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.patch(`/api/user-universities/${user_university_uuid}`, data)
				.then((res) => {
					this.$auth.setUser({
						...this.$auth.user,
						universities: res.data,
					});

					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	deleteUserUniversity(state: any, user_university_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete(`/api/user-universities/${user_university_uuid}`)
				.then((res) => {
					const universities = this.$auth.user.universities.filter(
						(v) => v.account.uuid !== user_university_uuid,
					);

					this.$auth.setUser({
						...this.$auth.user,
						universities: universities,
					});

					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	markUserUniversityAsVerified(state: any, payload: any) {
		const { user_university_uuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.put(
					`/api/user-universities/verification/${user_university_uuid}/verify`,
					data,
				)
				.then((res) => {
					this.$auth.setUser({
						...this.$auth.user,
						universities: res.data,
					});

					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	resendUniversityVerificationEmail(
		state: any,
		user_university_uuid: string,
	) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(
					`/api/user-universities/verification/${user_university_uuid}/resend`,
				)
				.then((res) => {
					this.$auth.setUser({
						...this.$auth.user,
						universities: res.data,
					});

					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},
};
